export function UpdatingLimitedProductQuantity(hash) {
  for (var key in hash) {
    $(`#remaining_limited_${key}`).text(`${hash[key]} panier${hash[key] > 1 ? 's' : ''}`)
  }
}